var map = {
	"./background-cost.png": 188,
	"./background-vp-negative.png": 189,
	"./background-vp-normal.png": 190,
	"./backgroundbribe.png": 191,
	"./backgroundcursed.png": 192,
	"./backgroundmetal.png": 193,
	"./backgroundshlevel.png": 194,
	"./backgroundsupermove1.png": 195,
	"./backgroundsupermove2.png": 196,
	"./backgroundsupermove3.png": 197,
	"./backgroundsupermove4.png": 198,
	"./backgroundsupermove5.png": 199,
	"./backgroundsupermove6.png": 200,
	"./backgroundsupermove7.png": 201,
	"./backgroundsupermove8.png": 202,
	"./backgroundsvlevel.png": 203,
	"./basic.png": 204,
	"./construct.png": 205,
	"./crisis.png": 206,
	"./destination.png": 207,
	"./equipment.png": 208,
	"./equipmenttransformed.png": 209,
	"./hero.png": 210,
	"./herotransformed.png": 211,
	"./hostage.png": 212,
	"./location.png": 213,
	"./nemesislevel.png": 214,
	"./oversized-super-hero.png": 215,
	"./oversized-super-villain.png": 216,
	"./oversizedcrisishero.png": 217,
	"./oversizedcrisisvillain.png": 218,
	"./oversizedlocation.png": 219,
	"./oversizedlocationv.png": 220,
	"./starter.png": 221,
	"./startertransformed.png": 222,
	"./super-hero.png": 223,
	"./super-move.png": 224,
	"./super-power.png": 225,
	"./super-villain.png": 226,
	"./supermove.png": 227,
	"./typeless.png": 228,
	"./villain.png": 229,
	"./villaintransformed.png": 230,
	"./vp-variable.png": 231,
	"./weakness.png": 232
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 144;


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates \.png$
// module id = 144
// module chunks = 0